import React, { useState, useEffect } from 'react';
import ScoreLimiterSkillDesktop from './desktop/ScoreLimiterSkill_Desktop';
import ScoreLimiterSkillMobile from './mobile/ScoreLimiterSkill_Mobile';

const ScoreLimiterSkill = (props) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile ? (
        <ScoreLimiterSkillMobile {...props} />
    ) : (
        <ScoreLimiterSkillDesktop {...props} />
    );
};

export default ScoreLimiterSkill;
// Revisado: 2025-12-18 [I18n Scan]
